import undoManager 	from 'undo-manager';
import eventBus                 from 'EventBus.js';
import listService      from 'ListService';
import util from 'util/Util.js';

// Wrapper Class so that we can override methods.
// at this point it's only the Add method we needed.

class UndoManagerService {

    constructor() {
        this.manager = new undoManager();
        this.manager.setLimit(25);

        this._redoText = [];
        this._undoText = [];
        this._hasChanges=false;
    }

    add(opts, undoEventText = '') {

        if (listService.loading) {
            return;
        }

        util.enableSaveOption();
        this._hasChanges= true;
        listService.isDirty = true;

        if (listService.mainKind === 'M') {
            return;
        }

        this.manager.add(opts);
        this._undoText.push(undoEventText);
       
        console.log("add undo redo");

        // #PF-4036 Adding tooltip only if the current view is the dashboard
        if(!listService.currentForm) {
           util.setUndoRedoAccess();
        }
        eventBus.trigger('undoCacheEvent');

        return this;
    }

    undo() {
        if (!listService.isUndoRedoEnabled){
            return;
        }

        let r = this.manager.undo();
        const val = this._undoText.pop();
        this._redoText.push(val);

        // #PF-4036 Adding tooltip only if the current view is the dashboard
        if(!listService.currentForm) {
          util.setUndoRedoAccess();
        }
        this._hasChanges= true;
        listService.isDirty = true;


        util.enableSaveOption();
        eventBus.trigger('undoCacheEvent');

        console.log("execute undo");
        return r;
    }

    redo() {
        if (!listService.isUndoRedoEnabled){
            return;
        }

        let r = this.manager.redo();

        const val = this._redoText.pop();
        this._undoText.push(val);

        // #PF-4036 Adding tooltip only if the current view is the dashboard
        if(!listService.currentForm) {
          util.setUndoRedoAccess();
        }

        this._hasChanges= true;
        listService.isDirty = true;
        console.log("execute redo");
        
        util.enableSaveOption();
        eventBus.trigger('undoCacheEvent');
        return r;
    }

    setCallback(callback) {
        this.manager.setCallback(callback);
    }

    clear() {
        this.manager.clear();
        this._redoText = [];
        this._undoText = [];
        this._hasChanges=false;
    }

    hasUndo() {
        return this.manager.hasUndo();
    }

    hasRedo() {
        return this.manager.hasRedo();
    }

    getCommands() {
        return this.manager.getCommands();
    }

    getIndex() {
        return this.manager.getIndex();
    }

    hasChanges() {
        return this._hasChanges || listService.isMobileDirty;
    }

    clearChangeTracker() {
        return this._hasChanges=false;
    }

    setLimit(limit) {
        this.manager.setLimit(limit);
    }

    get undoText() {
        let text = this._undoText.length > 0 ? this._undoText[this._undoText.length-1] : '';        
        text =  !listService.currentForm ? 
          'Undo ' + text :
          '<span class="actionName"><span class="context-item">Undo ' + text + '</span><span class="keyboard-shortcut">Ctrl+z</span></span>';
        return text;        
    }
  
    get redoText() {

        let text = this._redoText.length > 0 ? this._redoText[this._redoText.length-1] : '';
        text =  !listService.currentForm ?
          'Redo ' + text : 
          '<span class="actionName"><span class="context-item">Redo ' + text + '</span><span class="keyboard-shortcut">Ctrl+y</span></span>';
        return text;        
    }

}

const undoManagerService = new UndoManagerService();
export default undoManagerService;